"use client";

import { cn } from "@/lib/utils/cn";

interface NicoleIconProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  variant?: "filled" | "outline";
  className?: string;
}

const SIZES = {
  xs: { box: "w-6 h-6", text: "text-[9px]" },
  sm: { box: "w-8 h-8", text: "text-[11px]" },
  md: { box: "w-9 h-9", text: "text-xs" },
  lg: { box: "w-10 h-10", text: "text-sm" },
  xl: { box: "w-14 h-14", text: "text-lg" },
};

export default function NicoleIcon({ size = "md", variant = "filled", className }: NicoleIconProps) {
  const s = SIZES[size];
  if (variant === "outline") {
    return (
      <div className={cn(s.box, "rounded-button border-2 border-primary-500 flex items-center justify-center", className)}>
        <span className={cn(s.text, "font-black text-primary-500 tracking-tight select-none")} style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>N</span>
      </div>
    );
  }
  return (
    <div className={cn(s.box, "rounded-button bg-primary-500 flex items-center justify-center", className)}>
      <span className={cn(s.text, "font-black text-white tracking-tight select-none")} style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>N</span>
    </div>
  );
}
